// tslint:disable
import * as React from 'react';
import ReactGoogleMapLoader from 'react-google-maps-loader';
import ReactGooglePlacesSuggest from 'react-google-places-suggest';

export class MapsLoader extends React.Component<any, any>{
    public state: any = {
        search: '',
        value: '',
        placeData: false,
        lat: false,
        lng: false,
        eventPlace: false
    };

    private MY_API_KEY = 'AIzaSyAYT42w834bZxnkW9kTSiCaDvObp5KDmYo';

    handleInputChange = (e: any) => {
        this.setState({search: e.target.value, value: e.target.value});
    }


    handleSelectSuggest = async (geocodedPrediction: any, originalPrediction: any) => {
        if (this.props.onSelectSuggest) {
            this.props.onSelectSuggest(geocodedPrediction, originalPrediction);
        }

        this.setState({search: "", value: geocodedPrediction.formatted_address, placeData: geocodedPrediction})
    }

    onMapsInstanceRefValamiNemTudom (ref: any) {
        // if (ref && ref.props) {
        //     ref.props.params.language = 'en';
        //     ref.props.params.region = 'GB';
        //
        //     // console.log(ref.update)asd
        // }

    }

    render() {
        // const {search, value} = this.state
        return (
            <ReactGoogleMapLoader
                ref={(ref:ReactGoogleMapLoader) => (this.onMapsInstanceRefValamiNemTudom(ref))}
                params={{
                    key: this.MY_API_KEY,
                    libraries: 'places,geocode',
                    // language: 'en',
                    // region: 'GB'
                }}
                render={googleMaps =>
                    googleMaps && (
                        <ReactGooglePlacesSuggest
                            googleMaps={googleMaps}
                            autocompletionRequest={{
                                input: this.state.search,
                                // Optional options
                                // https://developers.google.com/maps/documentation/javascript/reference?hl=fr#AutocompletionRequest
                            }}
                            // Optional props
                            onSelectSuggest={this.handleSelectSuggest}
                            textNoResults='My custom no results text' // null or '' if you want to disable the no results item
                            customRender={prediction => (
                                <div className='customWrapper'>
                                    {prediction ? prediction.description : 'My custom no results text'}
                                </div>
                            )}>

                            <div className='form-group'>
                                <input
                                    type='text'
                                    value={this.state.value}
                                    placeholder='Search a location'
                                    className='form-control'
                                    onChange={this.handleInputChange}
                                />
                            </div>
                        </ReactGooglePlacesSuggest>
                    )
                }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/fields/MapsLoader.tsx